module.exports = __webpack_public_path__ + "static/img/tip.16811f70.png";